import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Domingo buscando actividades sobre el agro argentino que no están adaptadas al contexto rural ni a la currícula de Orientación Agro y Ambiente', 'Planificaciones para dirección armadas la noche anterior, a las corridas, con contenidos que no tienen secuencia ni hilo conductor', 'Siempre las mismas evaluaciones de opción múltiple porque no tenés un banco de instrumentos serios con criterios de corrección', 'El IAPI, el Grito de Alcorta, la sojización, el modelo agroexportador — sin actividades concretas ni fuentes adaptadas para el aula', 'Grupos con distintos años juntos sin material diferenciado — explicás al promedio y perdés a todos', 'Fin de semana agotado. El próximo domingo volvés a empezar el mismo ciclo.'];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark" data-id="element-147">
      <div className="max-w-3xl mx-auto" data-id="element-148">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-6 text-white leading-tight" data-id="element-149">
          ¿Cuántos domingos más vas a perder así?
        </h2>

        <p className="text-sm md:text-base text-gray-400 mb-8 text-center max-w-2xl mx-auto leading-relaxed" data-id="element-150">
          Sos docente de Historia, Ciencias Sociales o Producción Agropecuaria
          en una escuela rural o técnica. Amás lo que enseñás. Pero nadie te
          dijo que ibas a pasar los domingos buscando materiales que no encajan,
          armando evaluaciones a la noche y llegando al lunes con contenido que{' '}
          <span className="italic text-gray-300" data-id="element-151">"más o menos sirve"</span>.
        </p>

        <div className="bg-brand-card border-l-4 border-brand-accent p-5 md:p-6 rounded-r-lg mb-10" data-id="element-152">
          <p className="text-lg md:text-xl font-bold text-brand-accent mb-5 text-center neon-glow" data-id="element-153">
            No es falta de vocación. Es falta de un sistema.
          </p>

          <div className="space-y-3" data-id="element-154">
            {points.map((point, index) => <div key={index} className="flex items-start" data-id="element-155">
                <XCircle className="w-5 h-5 text-red-400 mr-3 shrink-0 mt-0.5" data-id="element-156" />
                <p className="text-sm md:text-base text-gray-300 font-medium" data-id="element-157">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-158">
          <h3 className="text-xl md:text-3xl font-black text-brand-accent neon-glow" data-id="element-159">
            ¿Y si este fuera el último domingo que pasás así?
          </h3>
        </div>
      </div>
    </section>;
}